interface Props {
  searchTerm: string;
  setSearch: (v: string) => void;
  fileTypeFilter: string;
  setTypeFilter: (v: string) => void;
  sortBy: 'date' | 'name' | 'size';
  setSortBy: (v: 'date' | 'name' | 'size') => void;
  clearFilters: () => void;
}

export function FileFilters({
  searchTerm,
  setSearch,
  fileTypeFilter,
  setTypeFilter,
  sortBy,
  setSortBy,
  clearFilters,
}: Props) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold text-navy mb-4">Filters & Search</h3>

      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1">
          <input
            type="text"
            placeholder="Search by filename..."
            value={searchTerm}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full px-3 py-2 bg-white border border-steel/30 rounded-md placeholder-steel/50 text-navy focus:outline-none focus:ring-2 focus:ring-orca-elevate focus:border-orca-elevate"
          />
        </div>

        <div className="w-full md:w-48">
          <select
            value={fileTypeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
            className="w-full px-3 py-2 bg-white border border-steel/30 rounded-md text-navy focus:outline-none focus:ring-2 focus:ring-orca-elevate focus:border-orca-elevate"
          >
            <option value="all">All Types</option>
            <option value="audio">Audio</option>
            <option value="text">Text</option>
            <option value="transcript">Transcript</option>
            <option value="document">Document</option>
          </select>
        </div>

        <div className="w-full md:w-48">
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value as 'date' | 'name' | 'size')}
            className="w-full px-3 py-2 bg-white border border-steel/30 rounded-md text-navy focus:outline-none focus:ring-2 focus:ring-orca-elevate focus:border-orca-elevate"
          >
            <option value="date">Sort by Date</option>
            <option value="name">Sort by Name</option>
            <option value="size">Sort by Size</option>
          </select>
        </div>
      </div>

      {(searchTerm || fileTypeFilter !== 'all') && (
        <div className="mt-3 flex items-center gap-2 text-sm text-steel">
          <span>Active filters:</span>
          {searchTerm && (
            <span className="px-2 py-1 bg-orca-elevate/10 text-orca-elevate rounded-md">
              Search: "{searchTerm}"
            </span>
          )}
          {fileTypeFilter !== 'all' && (
            <span className="px-2 py-1 bg-orca-elevate/10 text-orca-elevate rounded-md">
              Type: {fileTypeFilter}
            </span>
          )}
          <button
            onClick={clearFilters}
            className="text-red-600 hover:text-red-700 font-medium"
          >
            Clear All
          </button>
        </div>
      )}
    </div>
  );
}
